import { RollbackOutlined } from '@ant-design/icons'
import { Divider } from 'antd'
import React from 'react'
import { connect } from 'react-redux'
import { firestoreConnect, withFirestore } from 'react-redux-firebase'
import { Link } from 'react-router-dom'
import { compose } from 'redux'
import { Championship } from 'src/schemas/Championship'

import { hasRole } from '../../helpers/auth'
import { findInOrdered, fsCollections } from '../../helpers/firestore'
import { clearChampionship, selectChampionship } from '../../redux/modules/championships'

import { TenantId } from '../../schemas/Tenant'

type ChampionshipContainerProps = {
  admin: boolean
  children: any[]
  className?: string
  championship: Championship
  currentChampionship: Championship
  tenant: string
  // removeChampionship(id: string): void
  selectChampionship(tenant: TenantId, championship: Championship): void
  clearChampionship(): void
}

class ChampionshipContainer extends React.Component<ChampionshipContainerProps, any> {
  componentDidUpdate(prevProps, prevState, snapshot) {
    // need to pass `currentChampionship` otherwise - call stack overflow
    if (prevProps.championship.name && !this.props.currentChampionship) {
      this.props.selectChampionship(prevProps.tenant, prevProps.championship)
    }
  }

  componentWillUnmount() {
    this.props.clearChampionship()
  }

  render() {
    const { children, className = 'ant-col-12 ant-col-offset-6' } = this.props

    return (
      <div className={`container ${className}`}>
        <div className="TournamentMenu">
          <div>
            <Link key="home" to="/">
              <RollbackOutlined /> Home
            </Link>
          </div>
          <Divider />
        </div>
        {/*championship && championship.id && (
          <ChampionshipMenu
            tenant={tenant}
            admin={admin}
            tourney={championship}
            removeChampionship={removeChampionship}
          />
        )*/}
        {children}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { firestore, settings, firebase, championships } = state
  const { championshipId } = ownProps

  const { tenant } = settings
  const championship = findInOrdered(
    firestore.ordered[fsCollections.championships(tenant)],
    championshipId,
  )

  return {
    admin: hasRole('admin', tenant, firebase.profile),
    tenant,
    championship: {
      ...championship,
      id: championshipId, // needed by ChampionshipMenu
    },
    championshipCategories:
      firestore.ordered[fsCollections.championshipCategories(tenant, championshipId)],
    currentChampionship: championships.currentChampionship,
  }
}

export default compose<FIXME>(
  withFirestore,
  firestoreConnect<FIXME>(({ tenant, championshipId }) => [
    { collection: fsCollections.championships(tenant), doc: championshipId },
  ]),
  connect(mapStateToProps, { selectChampionship, clearChampionship }),
)(ChampionshipContainer)



// WEBPACK FOOTER //
// ./src/components/championship/ChampionshipContainer.tsx